import script from "./AppAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./AppAlert.vue?vue&type=script&setup=true&lang=js"

import "./AppAlert.vue?vue&type=style&index=0&id=bbfc8898&lang=scss"

const __exports__ = script;

export default __exports__